<template>
  <div>
    <el-row>
      <el-col>
        <form-section :title="$t('ConsentManager_Channels_Table')">
          <el-table
            :data="staticChannels"
            :border="true"
            :stripe="true"
            class="table-container"
            :show-header="true"
          >
            <el-table-column :label="$t('ConsentManager_Channels_Column_Name')">
              <template slot-scope="scope">
                <div>
                  {{ $t(scope.row.label) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('ConsentManager_Channels_Column_Key')">
              <template slot-scope="scope">
                <div>
                  {{ $t(scope.row.key) }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </form-section>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <form-section :title="$t('ConsentManager_Custom_Channels_Table')">
          <template slot="controls">
            <el-button
              v-if="$can('SubscriptionPreference::Create')"
              @click="addRow"
              type="primary"
              plain
              icon="el-icon-circle-plus-outline"
            >
              {{ $t('ConsentManager_Custom_Channels_AddButton') }}
            </el-button>
          </template>
          <rest-list-editable
            :payload="fetchEndpoint"
            :add-endpoint="rowAddEndpoint"
            ref="rest-list"
            :filterable="false"
          >
            <rest-list-column
              prop="name"
              :title="$t('ConsentManager_Channels_Column_Name')"
              :editable="true"
            >
              <template slot="input-edit" slot-scope="{ model }">
                <el-input
                  :placeholder="
                    $t('ConsentManager_Custom_Channels_NamePlaceholder')
                  "
                  v-model="model.name"
                />
              </template>
            </rest-list-column>
            <rest-list-column
              prop="key"
              :title="$t('ConsentManager_Channels_Column_Key')"
              :editable="true"
            >
              <template slot="input-edit" slot-scope="{ model }">
                {{ model.key }}
              </template>
            </rest-list-column>

            <rest-list-column-actions
              v-if="$can('SubscriptionPreference::Update')"
              :editable="true"
            >
              <template slot-scope="scope">
                <rest-list-action-delete
                  :endpoint="rowDeleteEndpoint(scope.row)"
                  :name="scope.row.name"
                />
              </template>
            </rest-list-column-actions>
          </rest-list-editable>
        </form-section>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { SubscriptionPreferenceChannelLabels } from '@/modules/settings/enum/SubscriptionPreferenceChannelEnum'
import RestListEditable from '@/common/components/rest/RestListEditable'
import { projectEndpoint } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import FormSection from '@/common/components/form/FormSection'
export default {
  name: 'ConsentManagerChannelsPage',
  components: {
    FormSection,
    RestListActionDelete,
    RestListColumnActions,
    RestListColumn,
    RestListEditable
  },
  data() {
    return {
      SubscriptionPreferenceChannelLabels,
      customChannels: []
    }
  },
  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `consent-channels`,
        params: {
          sort: 'name'
        }
      })
    },
    rowAddEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `consent-channels`
      })
    },
    staticChannels() {
      return Object.keys(SubscriptionPreferenceChannelLabels).map(key => {
        return { key: key, label: SubscriptionPreferenceChannelLabels[key] }
      })
    }
  },
  methods: {
    addRow() {
      const model = {
        name: ''
      }
      this.$refs['rest-list'].addRow(model)
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `consent-channels/${row.id}`
      })
    }
  }
}
</script>

<style scoped>
.table-container {
  border: 1px solid #dbdee7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/modules/consent-manager/pages/ConsentManagerChannelsPage.vue